'use client'

import { useEffect, useState } from 'react'
import BitMovinVideo from '@/utils/components/BitMovinVideo'
import { rewriteVodCdnManifestUrl } from '@/utils/manifestUrl'
import { getAuthenticatedUrl } from '@/utils/getAuthenticatedUrl'
import { proxyCmsVideo } from '@/utils/videoProxy'

type ArticleVideoBlockWrapperProps = {
  manifestUrl?: string | null
  title?: string
  description?: string
  className?: string
  videoId?: string
  videoType?: string
  videoTitle?: string
  videoPublishedDate?: string
}

export default function ArticleVideoBlockWrapper({
  manifestUrl,
  title,
  description,
  className,
  videoId,
  videoType,
  videoTitle,
  videoPublishedDate,
}: ArticleVideoBlockWrapperProps) {
  const [finalUrl, setFinalUrl] = useState('')

  useEffect(() => {
    let active = true

    const prepareUrl = async () => {
      if (!manifestUrl) {
        setFinalUrl('')
        return
      }

      console.log('[ArticleVideoBlock] raw manifest:', manifestUrl)
      const rewritten = rewriteVodCdnManifestUrl(manifestUrl)
      console.log('[ArticleVideoBlock] rewritten manifest:', rewritten)
      const authenticated = await getAuthenticatedUrl(rewritten)
      console.log('[ArticleVideoBlock] authenticated manifest:', authenticated)
      const proxied = proxyCmsVideo(authenticated)
      console.log('[ArticleVideoBlock] proxied final URL:', proxied)

      if (active) setFinalUrl(proxied)
    }

    void prepareUrl()
    return () => {
      active = false
    }
  }, [manifestUrl])

  return (
    <BitMovinVideo
      videoUrl={finalUrl}
      title={title}
      description={description}
      className={className}
      contentVideoPlayer="Bitmovin"
      videoId={videoId}
      videoType={videoType}
      videoTitle={videoTitle}
      videoPublishedDate={videoPublishedDate}
    />
  )
}
